<template>
    <div id="loginData" class="page-wrap" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>账号活跃</el-breadcrumb-item>
      </el-breadcrumb>
      <div style="padding: 20px;background-color: white;">
        <el-date-picker size="small" type="daterange" placeholder="选择日期" value-format="yyyy-MM-dd"
          v-model="searchformDate" :picker-options="pickerOptions" @change="getdataLoginAnalysis">
        </el-date-picker>
        <el-button size="small" style="margin-left: 20px;" @click="download">下载明细</el-button>
      </div>
      <div style="padding: 20px;background-color: white;margin-top: 20px;overflow: auto;">
        <div style="float: left;width: 25%;">
          <div style="color: gray;">
            登录次数
          </div>
          <div style="font-size: 30px;padding-top: 10px;">
            {{ loginAnalysisData.dealerNum }}次
          </div>
        </div>
  
        <div style="float: left;width: 25%;">
          <div style="color: gray;">
            登录数量
          </div>
          <div style="font-size: 30px;padding-top: 10px;">
            {{ loginAnalysisData.dealerNumber }}个
          </div>
        </div>
  
        <div style="float: left;width: 25%;">
          <div style="color: gray;">
            账号数量
          </div>
          <div style="font-size: 30px;padding-top: 10px;">
            {{ loginAnalysisData.dealerSum }}个
          </div>
        </div>
  
        <div style="float: left;width: 25%;">
          <div style="color: gray;">
            登录率
          </div>
          <div style="font-size: 30px;padding-top: 10px;">
            {{ loginAnalysisData.dealerRate }}
          </div>
        </div>
        <el-row style="padding-top: 60px;clear: both;">
          <el-col :span="19">
            <div style="font-size: 18px;font-weight: bold;">
              账号每日登录次数
            </div>
            <div id="main" style="height: 300px;width: 100%;"></div>
          </el-col>
          <el-col :span="5">
            <div style="font-size: 18px;font-weight: bold;margin-bottom: 20px;margin-left: 20px;">
              账号登录次数排名
            </div>
            <div v-for="(item, index) in list" v-if="index < 6"
              style="display: flex;height: 25px;line-height: 25px;margin-bottom: 20px;margin-left: 20px;">
              <div v-if="index < 3"
                style="background-color: rgb(47,70,89);height: 25px;width: 25px;color: white;text-align: center;line-height: 25px;border-radius: 50%;">
                {{ index + 1 }}
              </div>
              <div v-else style="height: 25px;width: 25px;text-align: center;line-height: 25px;">
                {{ index + 1 }}
              </div>
              <div style="padding-left: 20px;width: calc(100% - 74px);">
                {{ item.dealername }}
              </div>
              <div style="padding-left: 20px;">
                {{ item.dealernum }}
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </template>
  <script>
  export default {
    data() {
      return {
        searchformDate: [],
        pickerOptions: {
          shortcuts: [{
            text: '今日',
            onClick: (picker) => {
              this.getRecentDate(picker, 1);
            }
          }, {
            text: '近7日',
            onClick: (picker) => {
              this.getRecentDate(picker, 7);
            }
          }, {
            text: '近15日',
            onClick: (picker) => {
              this.getRecentDate(picker, 15);
            }
          }, {
            text: '近30日',
            onClick: (picker) => {
              this.getRecentDate(picker, 30);
            }
          }, {
            text: '近90日',
            onClick: (picker) => {
              this.getRecentDate(picker, 90);
            }
          }, {
            text: '近365日',
            onClick: (picker) => {
              this.getRecentDate(picker, 365);
            }
          }]
        },
        loginAnalysisData: {},
        list: [],
        loading: false,
      };
    },
    created() {
      this.getRecentDate();
    },
    mounted() {
      this.getdataLoginAnalysis()
    },
    methods: {
      getRecentDate(picker, n) {
        if (!n) {
          n = 7
        }
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * n);
        if (picker) {
          picker.$emit('pick', [start, end]);
        }
        if (n === 1) {
          this.searchformDate[0] = this.$options.filters['fullTime'](end).substring(0, 10);
          this.searchformDate[1] = this.$options.filters['fullTime'](end).substring(0, 10);
        } else {
          this.searchformDate[0] = this.$options.filters['fullTime'](start).substring(0, 10);
          this.searchformDate[1] = this.$options.filters['fullTime'](end).substring(0, 10);
        }
      },
      // 章子建数据接口
      getdataLoginAnalysis() {
        this.loading = true
        let params = {
          starttime: this.searchformDate[0],
          endtime: this.searchformDate[1]
        }
        fetch({
          url: "hcm/userout/dataLoginAnalysis",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          if (res.status == '10000') {
            this.loginAnalysisData = res.data
            this.list = res.data.List
            this.drawChart(res.data.dealerSeries[0], res.data.dateList)
            this.loading = false
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        }).catch(error => {
          this.$message.error('服务器错误~');
        })
      },
      // 个人排名
      drawChart(listUser, dateList) {
        // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
        let myChart = this.$echarts.init(document.getElementById("main"));
        // 指定图表的配置项和数据
        let name = dateList
        let userData = listUser.data
        let option = {
          tooltip: {
            trigger: 'axis',
          },
          toolbox: {
            feature: {
              saveAsImage: { show: true }
            }
          },
          xAxis: {
            type: 'category',
            data: name,
            axisPointer: {
              type: 'shadow'
            }
          },
          yAxis: [{
            type: 'value',
            // name: listUser.name,
            axisLine: {
              show: false, // 不显示坐标轴线
            },
            axisTick: {
              show: false // 不显示坐标轴刻度线
            },
            axisLabel: {
              formatter: '{value}'
            }
          }],
          series: [{
            // name: list[1].name,
            type: 'bar',
            barWidth: 30,
            color: '#4684FF',
            data: userData,
          }]
        };
        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);
      },
      // 下载
      download() {
        let datas = {
          starttime: this.searchformDate[0],
          endtime: this.searchformDate[1]
        }
        fetch({
          url: "hcm/userout/downloadUserTable",
          method: "get",
          params: datas,
          noFormat: true,
          responseType: "blob"
        }).then((res) => {
          //下载
          let url = window.URL.createObjectURL(new Blob([res]))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', '账号活跃信息.xlsx')
          document.body.appendChild(link)
          link.click()
        })
      },
    },
  };
  </script>
  <style>
  #loginData {
    margin: 20px;
  }
  </style>
  <style lang="scss" scoped></style>
  